import { render, staticRenderFns } from "./GameStatsEdit.vue?vue&type=template&id=803ddc0c&"
import script from "./GameStatsEdit.vue?vue&type=script&lang=js&"
export * from "./GameStatsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports